import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getUserList as getUserListApi,
  addUserList as addUserListApi,
  updateUserList as updateUserListApi,
  deleteUserList as deleteUserListApi,
  getUserGrid as getUserGridApi,
  addUserGrid as addUserGridApi,
  updateUserGrid as updateUserGridApi,
  deleteUserGrid as deleteUserGridApi,
} from "../../helpers/fakebackend_helper";

import {
  addSupplier as addSupplierApi,
  getUsersByRole as getUsersByRoleApi,
} from "../../helpers/backend_helper";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

export const getUserList = createAsyncThunk("users/getUserList", async () => {
  try {
    const response: any = await getUserListApi();
    const allUsers = response.result;
    const customers = allUsers.filter((user: any) => user.role === "customer");
    const suppliers = allUsers.filter((user: any) => user.role === "supplier");
    return { customers, suppliers };
  } catch (error) {
    console.log("getUserList:error", error);
    return error || "";
  }
});
export const addUserList = createAsyncThunk(
  "users/addUserList",
  async (event: any) => {
    try {
      const response = addUserListApi(event);
      const data = await response;
      toast.success("User Added Successfully", { autoClose: 2000 });
      return data;
    } catch (error) {
      toast.error("User Added Failed", { autoClose: 2000 });
      return error;
    }
  }
);
export const updateUserList = createAsyncThunk(
  "users/updateUserList",
  async (event: any) => {
    try {
      const response = updateUserListApi(event);
      const data = await response;
      toast.success("User updated Successfully", { autoClose: 2000 });
      return data;
    } catch (error) {
      toast.error("User updated Failed", { autoClose: 2000 });
      return error;
    }
  }
);
export const deleteUserList = createAsyncThunk(
  "users/deleteUserList",
  async (event: any) => {
    try {
      const response = deleteUserListApi(event);
      toast.success("User deleted Successfully", { autoClose: 2000 });
      return response;
    } catch (error) {
      toast.error("User deleted Failed", { autoClose: 2000 });
      return error;
    }
  }
);

export const getUserGrid = createAsyncThunk("users/getUserGrid", async () => {
  try {
    const response = getUserGridApi();
    return response;
  } catch (error) {
    return error;
  }
});
export const addUserGrid = createAsyncThunk(
  "users/addUserGrid",
  async (event: any) => {
    try {
      const response = addUserGridApi(event);
      const data = await response;
      toast.success("User Added Successfully", { autoClose: 2000 });
      return data;
    } catch (error) {
      toast.error("User Added Failed", { autoClose: 2000 });
      return error;
    }
  }
);
export const updateUserGrid = createAsyncThunk(
  "users/updateUserGrid",
  async (event: any) => {
    try {
      const response = updateUserGridApi(event);
      const data = await response;
      toast.success("User updated Successfully", { autoClose: 2000 });
      return data;
    } catch (error) {
      toast.error("User updated Failed", { autoClose: 2000 });
      return error;
    }
  }
);
export const deleteUserGrid = createAsyncThunk(
  "users/deleteUserGrid",
  async (event: any) => {
    try {
      const response = deleteUserGridApi(event);
      toast.success("User deleted Successfully", { autoClose: 2000 });
      return response;
    } catch (error) {
      toast.error("User deleted Failed", { autoClose: 2000 });
      return error;
    }
  }
);

// Customers
export const getCustomers = createAsyncThunk("users/getCustomers", async () => {
  try {
    const response: any = await getUsersByRoleApi("customer");
    return response.result.users;
  } catch (error) {
    console.log("getUserList:error", error);
    return error || "";
  }
});

// Suppliers
export const getSuppliers = createAsyncThunk("users/getSuppliers", async () => {
  try {
    const response: any = await getUsersByRoleApi("supplier");
    return response.result.users;
  } catch (error) {
    console.log("getUserList:error", error);
    return error || "";
  }
});

export const addSupplier = createAsyncThunk(
  "users/addSupplier",
  async (payload: any) => {
    try {
      const response: any = await addSupplierApi(payload);
      const data = response.result.data;
      toast.success("Supplier Added Successfully", { autoClose: 2000 });    
      return data;
    } catch (error) {
      toast.error("Supplier Added Failed", { autoClose: 2000 });
      return error;
    }
  }
);
